import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslocoModule } from "@ngneat/transloco";
import { SubscriptionPlan } from "clearline-api";

@Component({
  selector: "app-pricing-plan-card",
  templateUrl: "./pricing-plan-card.component.html",
  styleUrls: ["./pricing-plan-card.component.scss"],
  standalone: true,
  imports: [NgIf, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricingPlanCardComponent {
  @Input() plan: SubscriptionPlan;
  @Input() selectedPlanId: number;
  @Input() originalPlanId: number;

  @Output() selectPlan = new EventEmitter<SubscriptionPlan>();

  readonly oneTimeFee = 95;
  readonly locationPerAccount = 1;

  onSelectPlan(plan: SubscriptionPlan): void {
    this.selectPlan.emit(plan);
  }
}
